
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulamin-pracownika",
      function () {
        return require("private-next-pages/regulamin-pracownika.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulamin-pracownika"])
      });
    }
  